import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveFloat20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMoveFloat20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M18.959 11.422a.75.75 0 0 1-.715.784c-.9.042-1.513-.423-1.911-.71-.434-.314-.653-.45-.972-.438-.29.01-.483.14-.87.434-.361.274-.914.71-1.75.715-.847.005-1.41-.436-1.776-.713-.395-.298-.592-.429-.886-.436-.323-.008-.544.125-.963.423-.39.278-.981.725-1.851.726-.874.001-1.468-.447-1.86-.726-.421-.3-.643-.432-.967-.423-.292.008-.488.138-.881.436-.365.276-.925.716-1.769.713a.75.75 0 0 1 .006-1.5c.282.001.473-.118.857-.41.356-.269.91-.716 1.745-.74.881-.024 1.48.418 1.878.702.429.305.656.448.989.448.33 0 .557-.144.983-.447.397-.283.992-.724 1.87-.702.838.02 1.395.469 1.753.739.387.292.579.412.863.41.282-.002.47-.12.85-.41.352-.267.9-.709 1.727-.738.896-.032 1.508.435 1.903.72.431.312.648.443.963.428a.75.75 0 0 1 .784.715m-2.847-3.297a4 4 0 0 0-.587-.066h-.27c-.257.01-.498.045-.722.096a4.933 4.933 0 0 0-9.152.011 4 4 0 0 0-.764-.106l-.264-.001q-.286.009-.543.054a6.434 6.434 0 0 1 12.302.012m-.406 4.763a6.43 6.43 0 0 1-11.499-.011l.255-.187.025-.02.05.033c.3.214 1.036.785 2.114.954a4.9 4.9 0 0 0 3.308 1.275c1.266 0 2.42-.478 3.293-1.261 1.11-.154 1.848-.759 2.146-.985l.01-.008.047.033z"
            />
        </svg>
    );
}
export default memo(IconMoveFloat20);
